import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from './guards/admin.guard';
import { AuthenticateGuard } from './guards/authenticate.guard';
import { PageComponent } from './pages/page.component';

const routes: Routes = [
	{
		path: 'auth',
		loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
	},
	{
		path: '',
		component: PageComponent,
		canActivate: [AuthenticateGuard],
		children: [
			{
				path: 'alerts',
				loadChildren: () => import('./pages/alerts/alerts.module').then(m => m.AlertsModule),
			},
			{
				path: 'animals',
				loadChildren: () => import('./pages/animals/animals.module').then(m => m.AnimalsModule),
			},
			{
				path: 'groups',
				loadChildren: () => import('./pages/groups/groups.module').then(m => m.GroupsModule),
			},
			{
				path: 'compare',
				loadChildren: () => import('./pages/compare/compare.module').then(m => m.CompareModule),
			},
			{
				path: 'settings',
				loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule),
			},
			{
				path: 'companies',
				canActivate: [AdminGuard],
				loadChildren: () => import('./pages/companies/companies.module').then(m => m.CompaniesModule),
			},
			{
				path: 'crm-journal',
				canActivate: [AdminGuard],
				loadChildren: () => import('./pages/crm-journal/crm-journal.module').then(m => m.CrmJournalModule),
			},
			{
				path: 'breeds',
				canActivate: [AdminGuard],
				loadChildren: () => import('./pages/breeds/breeds.module').then(m => m.BreedsModule),
			},
			{
				path: 'externs',
				canActivate: [AdminGuard],
				loadChildren: () => import('./pages/externs/externs.module').then(m => m.ExternsModule),
			},
			{
				path: 'configuration',
				canActivate: [AdminGuard],
				loadChildren: () => import('./pages/configuration/configuration.module').then(m => m.ConfigurationModule),
			},
			{
				path: 'timeline',
				canActivate: [AdminGuard],
				loadChildren: () => import('./pages/timeline/timeline.module').then(m => m.TimelineModule),
			},
			{
				path: 'kpis',
				canActivate: [AdminGuard],
				loadChildren: () => import('./pages/kpis/kpis.module').then(m => m.KpisModule),
			},
			{
				path: 'weighing-sessions',
				loadChildren: () => import('./pages/weighing-sessions/weighing-sessions.module').then(m => m.WeighingSessionsModule),
			},
		]
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
